// src/pages/admin/AdminDashboard.js
// Home del panel superadmin: 3 tarjetas con totales + accesos rápidos.

import React, { useEffect, useState } from 'react';
import { Grid, Card, CardContent, Typography, Box, Skeleton, Alert } from '@mui/material';
import PeopleIcon     from '@mui/icons-material/People';
import StorefrontIcon from '@mui/icons-material/Storefront';
import PersonIcon     from '@mui/icons-material/Person';
import { admin } from '../../api/authApi';

export default function AdminDashboard() {
  const [stats, setStats] = useState({ usuarios: null, negocios: null, vecis: null });
  const [error, setError] = useState('');

  useEffect(() => {
    (async () => {
      try {
        const [u, n, v] = await Promise.all([
          admin.usuariosListar({ page: 1, size: 1 }),
          admin.negociosListar({ page: 1, size: 1 }),
          admin.vecisListar   ({ page: 1, size: 1 }),
        ]);
        setStats({ usuarios: u.total, negocios: n.total, vecis: v.total });
      } catch (e) {
        setError(e.mensajeUsuario || 'No se pudieron cargar los indicadores.');
      }
    })();
  }, []);

  const tarjeta = (label, valor, icon, color) => (
    <Grid item xs={12} sm={6} md={4}>
      <Card>
        <CardContent>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Box sx={{
              width: 56, height: 56, borderRadius: 2, bgcolor: color,
              color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center',
            }}>
              {icon}
            </Box>
            <Box>
              <Typography variant="caption" color="text.secondary" textTransform="uppercase">{label}</Typography>
              {valor === null
                ? <Skeleton width={80} height={40} />
                : <Typography variant="h4" fontWeight={700}>{valor}</Typography>}
            </Box>
          </Box>
        </CardContent>
      </Card>
    </Grid>
  );

  return (
    <Box>
      <Typography variant="h4" sx={{ fontFamily: 'Fraunces', mb: 3 }}>
        Panel de control
      </Typography>

      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

      <Grid container spacing={2}>
        {tarjeta('Usuarios totales', stats.usuarios, <PeopleIcon />,     '#0F4C3A')}
        {tarjeta('Negocios',         stats.negocios, <StorefrontIcon />, '#B45309')}
        {tarjeta('Vecis',            stats.vecis,    <PersonIcon />,     '#1976d2')}
      </Grid>
    </Box>
  );
}
